/*
 * Copyright (c) 2026. Tooling Team
 */

const LAB_DOMAIN_COOKIE = "showLabDomain";

export const getLabDomainVisibility = () => {
  return (
    document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((row) => row.startsWith(`${LAB_DOMAIN_COOKIE}=`))
      ?.split("=")[1] === "true"
  );
};

export const setLabDomainVisibility = (value) => {
  const secureFlag = window.location?.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${LAB_DOMAIN_COOKIE}=${value}; path=/; max-age=31536000; SameSite=Lax${secureFlag}`;
};
